let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aly08")).then(() => parcelRequire('lE3ki'));